namespace SolovisGateway.Admin.Accounts {

    export class TermsOfServiceControl extends Solovis.UI.BaseControl {

        public static _bottomScrollBufferZone = 5;

        private _tosDiv;
        private _contentHtml;
        private _tosId;

        private _hasSeenEndOfTos = false;

        private _acceptCheckBoxDiv;
        private _acceptButtonDiv;
        private _tosHtmlContent;

        private _targetUrl;
        private _latestTOSId;
        private _canUserAccept;

        constructor(options) {
            super(options);

            this._targetUrl = options.targetUrl ? options.targetUrl : null;
            this._tosHtmlContent = options.tosHtmlContent ? options.tosHtmlContent : null;
            this._latestTOSId = options.latestTOSId ? options.latestTOSId : null;
            this._canUserAccept = options.canUserAccept != null ? options.canUserAccept : false;
        }

        public async doInitAsync(): Promise<void> {
            this._contentHtml = this._tosHtmlContent;
            this._tosId = this._latestTOSId;
        }

        public doRender() {
            let tosDiv = $("<div>")
                .css("overflow", "auto")
                .css("height", "400px")
                .css("padding", "10px")
                .css("border", "1px solid #ccc");

            tosDiv.html(this._contentHtml);
            this._tosDiv = tosDiv;

            $(tosDiv).on('scroll', () => {
                this._updateHasSeenEndOfTos();
            }); 

            this.container.append(tosDiv);

            this._updateHasSeenEndOfTos();

            let acceptCheckBoxRowDiv = $("<div>").css("padding-top", "10px").appendTo(this.container);

            this._acceptCheckBoxDiv = $("<div>").appendTo(acceptCheckBoxRowDiv);
            $(this._acceptCheckBoxDiv).dxCheckBox({
                text: "I have reviewed and accept the 'Terms Of Service'.",
                disabled: !this._hasSeenEndOfTos,
                visible: this._canUserAccept,
                onValueChanged: () => this._updateEnabledStates()
            });

            let acceptButtonRowDiv = $("<div>").css("padding-top", "10px").appendTo(this.container);

            this._acceptButtonDiv = $("<div>").appendTo(acceptButtonRowDiv);
            $(this._acceptButtonDiv).dxButton({
                text: "Accept",
                onClick: () => {
                    this._doAcceptAsync();
                },
                visible: this._canUserAccept,
                disabled: true
            });
        }

        private _updateHasSeenEndOfTos() {
            if (!this._hasSeenEndOfTos && this._isEndOfTosVisible()) {
                this._hasSeenEndOfTos = true;
                this._updateEnabledStates();
            }
        }

        private _updateEnabledStates() {
            if (this._hasSeenEndOfTos) {
                $(this._acceptCheckBoxDiv).dxCheckBox("option", "disabled", false);

                let isChecked = $(this._acceptCheckBoxDiv).dxCheckBox("option", "value");
                $(this._acceptButtonDiv).dxButton("option", "disabled", !isChecked);
            }
        }

        private _isEndOfTosVisible() {
            // Don't require exact scroll the bottom (some browsers may prevent this lining up perfectly)
            let bufferZone = TermsOfServiceControl._bottomScrollBufferZone;

            if ((bufferZone + $(this._tosDiv).scrollTop() + $(this._tosDiv).innerHeight()) >= $(this._tosDiv)[0].scrollHeight) {
                return true;
            }
            return false;
        }

        private async _doAcceptAsync(): Promise<void> {            
            await Solovis.Rpc.invokeAndWait("~/Account/AcceptTermsOfService", { termsOfServiceId: this._tosId });

            let nextUrl = this._targetUrl ? this._targetUrl : Solovis.resolveFullUrl("/");
            window.location.replace(nextUrl);
        }

    }

}